import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend } from 'recharts';

export default function ResultsRadar({ dimensionDefs, dimensions, benchmarkPercent }) {
  const data = dimensionDefs.map((def) => ({
    dimension: def.short || def.label,
    You: dimensions[def.key]?.percent ?? 0,
    'Typical SMB': benchmarkPercent,
  }));

  return (
    <ResponsiveContainer width="100%" height={360}>
      <RadarChart data={data} outerRadius="75%">
        <PolarGrid stroke="#E5E7EB" />
        <PolarAngleAxis dataKey="dimension" tick={{ fontSize: 12, fill: '#374151' }} />
        <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ fontSize: 10, fill: '#9CA3AF' }} />
        <Radar
          name="Typical SMB"
          dataKey="Typical SMB"
          stroke="#9CA3AF"
          strokeDasharray="4 4"
          fill="#9CA3AF"
          fillOpacity={0.08}
        />
        <Radar
          name="You"
          dataKey="You"
          stroke="#2c5282"
          fill="#2c5282"
          fillOpacity={0.35}
          strokeWidth={2}
        />
        <Legend />
      </RadarChart>
    </ResponsiveContainer>
  );
}
